import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import cn from 'classnames';
import styles from './Collection.scss';
import noBuildings from 'assets/images/no_photo/no_photo_150px.png';

import { removeFromCollection, addComment } from '../../actions/collections';
import { ROOT_URL } from '../../constants/Config';
import tracker from '../../services/tracker';
import { withTranslation } from 'react-i18next';


class Collection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editing: false,
      comment: props.building.comment
    };
  }

  componentDidMount() {

  }

  handleChange = (e) => {
    this.setState({
      comment: e.target.value
    });
  };

  getInputRef = (ref) => {
    this.input = ref;
  }

  handleEditClick = () => {
    tracker.sendEvent('Web_Selections_Edit_Comment');
    this.setState({
      editing: true,
      comment: this.props.building.comment
    });
    this.input.focus();
  };

  handleCancleClick = () => {
    this.setState({
      editing: false,
      comment: this.props.building.comment
    });
  };

  handleCommentClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    tracker.sendEvent('Web_Selections_Add_Comment');
    this.setState({
      editing: !this.state.editing
    });
    this.input.focus();
  };

  handleCommentSubmit = (e) => {
    e.preventDefault();
    const { addComment, referal, building } = this.props;
    addComment({
      referal,
      buildingId: building.id,
      comment: this.state.comment
    });
    this.setState({
      editing: false
    });
  };

  handleRemoveClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const { removeFromCollection, referal, building, collectionName } = this.props;
    tracker.sendEvent('Web_Selections_Delete_Comment', {
      id: building.id,
      name: building.title
    });
    removeFromCollection(
      {
        referal,
        buildingId: building.id
      },
      {
        collectionName,
        buildingName: building.title,
        data: building
      }
    );
  };

  render() {
    const { t } = this.props;
    const {
      title,
      address,
      comment,
      image,
      id: buildingId,
      construction_finished: isFinished,
      construction_ending: quater,
      year_built: year,
      status
    } = this.props.building;

    const imageId = image && image.id;

    return (
      <div className={cn(styles.ItemWrap, { [styles.ItemActive]: comment || this.state.comment || this.state.editing })}>
        <Link to={`/building/${buildingId}`} className={styles.Item}>
          <div className={cn(styles.ItemImage, { [styles.ItemImageNoImage]: !image })}>
            {image ? <img src={`${ROOT_URL}/image?id=${imageId}&size=medium`} alt="" /> : <img src={noBuildings} alt="" /> }
          </div>
          <p className={styles.ItemTitle}>
            <span>{title}</span>{' '}
            <span className={styles.LotTag}>
              {t('components.collectionItem.lot', { buildingId })}
            </span>
            {status == 3 ? (
              <span className={cn(styles.ItemStatus, styles.AlmostFinished)}>
                {t('components.collectionItem.almostFinished')}
              </span>
            ) : (
              <span className={cn(styles.ItemStatus, { [styles.Finished]: isFinished })}>
                {isFinished ? t('components.collectionItem.finished') : (
                  `${quater} / ${year || ''}`
                )}
              </span>
            )}
          </p>
          <p className={styles.ItemAddress}>
            <span>{address}</span>
          </p>
          <div className={styles.ItemCommentButton} onClick={this.handleCommentClick}>
            <span className={styles.TabletHidden}>{t('components.collectionItem.addComment')}</span> <span className={styles.TabletOnly}>{t('components.collectionItem.comment')}</span></div>
          <div className={styles.ItemDelete} onClick={this.handleRemoveClick}>
            {t('components.collectionItem.delete')}
          </div>
        </Link>
        <form className={styles.ItemComment} onSubmit={this.handleCommentSubmit}>
          <input
            placeholder={this.state.editing ? t('components.collectionItem.writeComment') : ''}
            value={this.state.comment || ''}
            className={styles.CommentInput}
            onChange={this.handleChange}
            ref={this.getInputRef}
          />
          <div className={styles.CommentButtons}>
            {
              this.state.editing ?
                <div className={styles.CommentButton} onClick={this.handleCancleClick}>
                  {t('components.collectionItem.cancel')}
                </div> :
                <div className={styles.CommentButton} onClick={this.handleEditClick}>
                  {t('components.collectionItem.edit')}
                </div>
            }
            { this.state.editing && this.state.comment !== comment &&
              <button className={styles.CommentButton}>
                {t('components.collectionItem.save')}
              </button>
            }
          </div>
        </form>
      </div>
    );
  }
}

export default connect(
  state => ({
    referal: state.collection.selection.referal,
    collectionName: state.collection.selection.name
  }),
  { removeFromCollection, addComment }
)(withTranslation()(Collection));



// WEBPACK FOOTER //
// ./src/components/CollectionItem/Collection.js